import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { paintSurfaces } from './surfaces';
import { loadArt } from './table/materials';
import './styles.css';
import './table/fonts';

// The generated art first: a table drawn before its images arrive keeps the
// noise-painted stand-ins. Give up waiting after a few seconds on a slow link.
const ART_WAIT_MS = 4000;
void Promise.race([loadArt(), new Promise((done) => setTimeout(done, ART_WAIT_MS))]).then(() => {
  paintSurfaces();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
